
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ProductionWindowChart from './ProductionWindowChart';
import ProductionLinuxChart from './ProductionLinuxChart';

const PathManagement = () => {
    

    return(
        <>
          <Row>
              <Col className='path-management-border' lg={6}>
                <div className="path-management-div">
                  <h1 className="path-management-title">Production</h1>
                </div>
                <div className='path-chart-header'>
                  <ProductionWindowChart />
                </div>  
                <div className='path-chart-header'>
                  <ProductionLinuxChart />
                </div>
              </Col>
              <Col lg={6}>
                <div className="path-management-div">
                  <h1 className="path-management-title">Non - Production</h1>
                </div>
                <div className='path-chart-header'>
                  <ProductionWindowChart />
                </div>  
                <div className='path-chart-header'>
                  <ProductionLinuxChart />
                </div>
              </Col>
          </Row>
        </>
    )
}

export default PathManagement;